import React from 'react';
import EventsContainer from './EventsContainer';
import MonthViewSidebar from './MonthViewSidebar';

export default class MonthView extends React.Component {
  constructor(props) {
    super(props);
    
    const now = new Date();
    this.formatTitle = new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric'}).format;

    this.state = {};
    if (this.props.selected) {
      try {
        const [day, month, year] = this.props.selected.split('-');
        if (day && month && year) {
          console.log('hi')
          console.log(year);
          console.log(new Date(year, month - 1, day))
          this.state.selected = new Date(year, month, day);
        } else {
          this.state.selected = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        }
      } catch (e) {
        console.error('Could not parse month in query stirng.');
      }
    } else {
      this.state.selected = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    }

    this.changeSelectedDate = this.changeSelectedDate.bind(this);
  }

  changeSelectedDate(newDate) {
    const dateString = [
      newDate.getDate(), 
      newDate.getMonth(), 
      newDate.getFullYear()
    ].join('-');
    const oldHash = document.location.hash;
    document.location.hash = oldHash.replace(/\/.*$/, '/' + dateString);

    this.setState({ selected: newDate });
  }

  render() {
    const endDate = new Date(this.state.selected);
    endDate.setDate(endDate.getDate() + 1);

    return(
      <div className="events-container">
        <MonthViewSidebar
          active={this.state.selected}
          changeSelectedDate={this.changeSelectedDate}
         />
        <EventsContainer
          title={this.formatTitle(this.state.selected)}
          startDate={this.state.selected}
          endDate={endDate}
          perPage={9}
          showEnded
          noBackDate
          mode={this.props.mode}
         />
      </div>
    );
  }
}